import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/PageHeader";
import { useApiParameters } from "@/hooks/useApiParameters";
import { ScheduleDetailsNavigation } from "@/routes/_auth/app/_app/org/$orgId/schedules/-components/ScheduleDetailsNavigation";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/schedules/$scheduleId",
)({
	beforeLoad: ({ context }) => {
		if (!context.userId) {
			throw new Error("Not authenticated");
		}
	},
	loader: async ({ context }) => {
		const { userId, token } = useApiParameters(
			context.userId,
			await context.get_token(),
		);

		return { userId, token };
	},
	component: ScheduleDetailsLayout,
});

function ScheduleDetailsLayout() {
	const { t } = useTranslation();
	const { userId, token } = Route.useLoaderData();
	const location = useLocation();

	// Determine active tab based on current route
	const getActiveTab = () => {
		const pathname = location.pathname;
		if (pathname.endsWith("/enrollments")) return "enrollments";
		if (pathname.endsWith("/sessions")) return "sessions";
		return "edit"; // default for index route
	};

	return (
		<div className="flex flex-col h-full">
			<PageHeader
				title={t("schedules.details.title")}
				description={t("schedules.details.description")}
				showBackButton={true}
				backButtonText={t("common.back")}
				hideOnMobile={false}
			/>

			{/* Main content area with side navigation */}
			<div
				className="flex-1 flex h-[calc(100vh-4rem)] min-h-0 overflow-hidden"
				data-testid="schedule-details-container"
			>
				{/* Side Navigation */}
				<ScheduleDetailsNavigation
					activeTab={getActiveTab()}
					userId={userId}
					token={token}
				/>

				{/* Main Content Area */}
				<div
					className="flex-1 p-3 md:p-4 bg-base-200 min-h-0 overflow-hidden"
					data-testid="schedule-details-main-content-area"
				>
					<Outlet />
				</div>
			</div>
		</div>
	);
}
